/**
 * A host shown as a name and a handle (14 Oct 2026): a battle keeps one hostName, and a trailing @handle is split off so
 * "Abdul-Aziz Ansari @theabdulazizansari" reads as the name, with the handle on its own line under it. A handle alone,
 * or a name with no handle, stays one line.
 */
export function hostParts(hostName: string): { name: string; handle?: string } {
  const s = hostName.trim().replace(/\s+/g, ' ');
  const m = /^(.+?) (@[A-Za-z0-9_.]{1,30})$/.exec(s);
  return m ? { name: m[1], handle: m[2] } : { name: s };
}
